var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { axiosInstance } from './client';
import { getConfigData, getOnCatch, getOnThen, getTypePrefix } from './helpers';
function handleError(requestType) {
    return (requestType === 'interaction' ||
        requestType === 'common' ||
        requestType === 'community' ||
        requestType === 'application');
}
var HttpServices = /** @class */ (function () {
    function HttpServices() {
    }
    HttpServices.prototype.get = function (_a) {
        return __awaiter(this, arguments, Promise, function (_b) {
            var prefix, configData;
            var path = _b.path, data = _b.data, signal = _b.signal, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.requestType, requestType = _d === void 0 ? 'widget' : _d, _e = _b.rethrow, rethrow = _e === void 0 ? true : _e;
            return __generator(this, function (_f) {
                prefix = getTypePrefix(requestType);
                configData = getConfigData(withCredentials, data);
                if (signal) {
                    configData.signal = signal;
                }
                return [2 /*return*/, axiosInstance
                        .get(prefix + path, configData)
                        .then(function (response) { return getOnThen(response, handleError(requestType)); })
                        .catch(function (error) { return getOnCatch(error, handleError(requestType), rethrow); })];
            });
        });
    };
    HttpServices.prototype.post = function (_a) {
        return __awaiter(this, arguments, Promise, function (_b) {
            var prefix, config;
            var path = _b.path, data = _b.data, signal = _b.signal, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.requestType, requestType = _d === void 0 ? 'widget' : _d, _e = _b.rethrow, rethrow = _e === void 0 ? true : _e;
            return __generator(this, function (_f) {
                prefix = getTypePrefix(requestType);
                config = getConfigData(withCredentials);
                if (signal) {
                    config.signal = signal;
                }
                return [2 /*return*/, axiosInstance
                        .post(prefix + path, data, config)
                        .then(function (response) { return getOnThen(response, handleError(requestType)); })
                        .catch(function (error) { return getOnCatch(error, handleError(requestType), rethrow); })];
            });
        });
    };
    HttpServices.prototype.put = function (_a) {
        return __awaiter(this, arguments, Promise, function (_b) {
            var prefix, confiog;
            var path = _b.path, data = _b.data, signal = _b.signal, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.requestType, requestType = _d === void 0 ? 'widget' : _d, _e = _b.rethrow, rethrow = _e === void 0 ? true : _e;
            return __generator(this, function (_f) {
                prefix = getTypePrefix(requestType);
                confiog = getConfigData(withCredentials);
                if (signal) {
                    confiog.signal = signal;
                }
                return [2 /*return*/, axiosInstance
                        .put(prefix + path, data, confiog)
                        .then(function (response) { return getOnThen(response, handleError(requestType)); })
                        .catch(function (error) { return getOnCatch(error, handleError(requestType), rethrow); })];
            });
        });
    };
    HttpServices.prototype.delete = function (_a) {
        return __awaiter(this, arguments, Promise, function (_b) {
            var prefix, configData;
            var path = _b.path, data = _b.data, signal = _b.signal, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.requestType, requestType = _d === void 0 ? 'widget' : _d, _e = _b.rethrow, rethrow = _e === void 0 ? true : _e;
            return __generator(this, function (_f) {
                prefix = getTypePrefix(requestType);
                configData = getConfigData(withCredentials, data);
                if (signal) {
                    configData.signal = signal;
                }
                return [2 /*return*/, axiosInstance
                        .delete(prefix + path, configData)
                        .then(function (response) { return getOnThen(response, handleError(requestType)); })
                        .catch(function (error) { return getOnCatch(error, handleError(requestType), rethrow); })];
            });
        });
    };
    HttpServices.prototype.formData = function (_a) {
        return __awaiter(this, arguments, Promise, function (_b) {
            var prefix, config;
            var path = _b.path, data = _b.data, signal = _b.signal, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.requestType, requestType = _d === void 0 ? 'widget' : _d, _e = _b.rethrow, rethrow = _e === void 0 ? true : _e;
            return __generator(this, function (_f) {
                prefix = getTypePrefix(requestType);
                config = getConfigData(withCredentials, undefined, data);
                if (signal) {
                    config.signal = signal;
                }
                return [2 /*return*/, axiosInstance
                        .put(prefix + path, data, config)
                        .then(function (response) { return getOnThen(response, handleError(requestType)); })
                        .catch(function (error) { return getOnCatch(error, handleError(requestType), rethrow); })];
            });
        });
    };
    return HttpServices;
}());
export var httpServices = new HttpServices();
